"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketApiErrorMapping = void 0;
const httpStatus_1 = require("./httpStatus");
exports.marketApiErrorMapping = {
    [httpStatus_1.HttpStatus.INTERNAL_SERVER_ERROR]: {
        code: "MARKET_API_INTERNAL_SERVER_ERROR",
        message: "The market API responded with an error indicating a technical problem",
    },
    [httpStatus_1.HttpStatus.SERVICE_UNAVAILABLE]: {
        code: "MARKET_API_SERVICE_UNAVAILABLE",
        message: "The market API is currently unavailable",
    },
};
//# sourceMappingURL=errorCodes.js.map